export default __webpack_public_path__ + "images/1c46defb5d0c6d37590cedf347310214-music.webp";